module.exports = __webpack_public_path__ + "img/dictionary.9188cb44.svg";